module.exports = __webpack_public_path__ + "images/drawings/bud_status_3.ce136d4888041ff79064d878a4a63419.png";